export var formLabelLocale = {
  optional: '(optional)'
};